module.exports = __webpack_public_path__ + "img/ITEC.f1d61cf5.png";